import noop from 'lodash-es/noop'
import cloneDeep from 'lodash-es/cloneDeep'

import { getCurrentUser, extend, logout } from '../services/userProfile'
import { setUserId } from '../lib/firebase'
import { shouldForceUserRefresh } from '../lib/user'
import { USER_ROLES } from '../lib/constants'

const validRoles = {
  insider: [
    USER_ROLES.administrator,
    USER_ROLES.business_member,
    USER_ROLES.customer_service,
    USER_ROLES.editor,
    USER_ROLES.insider,
    USER_ROLES.insider_plus,
    USER_ROLES.insider_trial,
  ], 
  mapsPro: [
    USER_ROLES.explorer_trial,
    USER_ROLES.explorer,
    USER_ROLES.maps_pro_trial,
    USER_ROLES.maps_pro
  ]
}

const isInsider = userRoles => {
  const hasValidRole = userRoles.find(ur => validRoles.insider.includes(ur))
  return hasValidRole ? true : false
}

const isMapsPro = userRoles => {
  const hasValidRole = userRoles.find(ur => validRoles.mapsPro.includes(ur))
  return hasValidRole ? true : false
}

const trialsAllowed = allowTrial => {
  return {
    explorer: allowTrial.explorer_trial,
    insider: allowTrial.insider_trial
  }
}

export default {
  namespace: 'user',
  state: {
    profile: {
      mapPreferences: {
        elevationExaggeration: 0
      }
    },
    currentUser: null
  },
  effects: {
    *getCurrentUserProfile({ callback = noop }, { call, put }) {
      let response = yield call(getCurrentUser)

      if (response.success) {
        let profile = { ...response.data }
        profile.isInsider = isInsider(profile.roles)
        profile.isMapsPro = isMapsPro(profile.roles)
        profile.isRegisteredUser = profile.roles.includes(USER_ROLES.registered)
        profile.trialsAllowed = trialsAllowed(profile.allowTrial)

        setUserId(profile.tracker)

        profile.mapPreferences = {
          elevationExaggeration: 1
        }

        yield put({ type: 'setProfile', payload: profile })
        callback()
      }
    },
    *logout({ callback = noop }, { call }) {
      /*
        #TODO: In development, Maps is standalone, but in
        production, Maps is served behind 2.0 which needs to
        account for logging out of Drupal and Shopify. We can
        add a switch in the url to account for different build
        versions.
        -- WD - June 19, 2020
      */
      let response = yield call(logout)
      // eslint-disable-next-line no-undef

      callback(response.success)
    }
  },
  reducers: {
    setProfile(state, { payload }) {
      return {
        ...state,
        profile: cloneDeep(payload)
      }
    },
    setCurrentUser(state, { payload }) {
      return {
        ...state,
        currentUser: payload
      }
    },
    setMapPreferences(state, { payload }) {
      return {
        ...state,
        profile: {
          ...state.profile,
          mapPreferences: {
            ...state.mapPreferences,
            ...payload
          }
        }
      }
    }
  },

  subscriptions: {
    userRefresh: ({ dispatch }) => {
      const refreshFn = window.setInterval(() => {
        const forceRefresh = shouldForceUserRefresh()
        extend(null, forceRefresh).then(() => {
          dispatch({
            type: 'map/updateInterceptor'
          })
        })
      }, 15 * 60 * 1000)
      return () => window.clearInterval(refreshFn)
    }
  }
}
